export default {
    id: "7",
    images: "https://uc.udn.com.tw/photo/2021/04/16/1/12105220.jpg",
    type: "益智遊戲",
    name: "雙人成行",
    play: "PS5/PC",
    number: "2人",
    date: "2021年2月25日",
    Make: "Hazelight Studios",
    price: "1290",
    link: "",
    intro: "《雙人成行》是一款帶有平台遊戲元素的動作冒險遊戲，專為多人分割畫面合作遊戲設計，這意味著必須通過本地或線上模式與另一個玩家共同遊玩。遊戲採用了來自各種電子遊戲類型的大量遊戲機制，這些遊戲機制與故事和關卡的主題有關。例如，在一個關卡中，科迪獲得了時間倒流的能力，而小梅則可以複製自己。玩家必須相互配合，利用這些能力推進劇情。遊戲中還有大量的迷你遊戲"
}






// WEBPACK FOOTER //
// ./src/database/game7.js